import { markRaw } from "vue";

import type { PiniaPluginContext } from "pinia";
import type { RouteLocationNormalizedLoadedGeneric, Router } from "vue-router";

export function routerPlugin(router: Router) {
  return ({ store }: PiniaPluginContext) => {
    store.router = markRaw(router);
    Object.defineProperty(store, "currentRoute", {
      // Reading the router's ref tracks the committed route even though the router itself is raw.
      get: () => router.currentRoute.value,
    });
  };
}

declare module "pinia" {
  export interface PiniaCustomProperties {
    router: Omit<Router, "currentRoute">;
    readonly currentRoute: RouteLocationNormalizedLoadedGeneric;
  }
}
